module.exports = __webpack_public_path__ + "img/lucaservers.82edbac5.png";